import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const BonusTransactionStatusFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const transactionState = useAppSelector((state) => state.transactions.bonusStatuses)
  const data = transactionState.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Bonus Transaction Status'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
